import { memo, useContext } from 'react';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { QaRecordsContext } from '../../helper';
import { createQaRecordId } from '@/sub-luca-plugin/utils/qa';
import { IGuessYouLike } from '..';
import { AnimationContainer } from '@/sub-luca-plugin/compatible-components';
import './index.scss';

const GuessYouAsk = ({ questions }: Pick<IGuessYouLike, 'questions'>) => {
    const { getQaStoreByContext, toastInQa } = useContext(QaRecordsContext);
    const handleQa = (content: string) => {
        const { validateCanSend, pushQaRecords, qaConfig, updateQaConfig, interruptAllExcute } = getQaStoreByContext()!;
        if (!validateCanSend?.(['replying', 'ocrAndGptReplying'])) return;
        if (qaConfig.questionState === 2) {
            toastInQa?.('已解决，不可发送快捷消息');
            return;
        }
        if (qaConfig.transferLaborState === 1) {
            toastInQa?.('已转名师答疑，不可发送快捷消息');
            return;
        }
        if (qaConfig.lucaQuestionAgainNum! <= 0) {
            toastInQa?.('追问次数已用完');
            return;
        }
        interruptAllExcute('send_cancel');
        updateQaConfig({ showWhetherSolve: false });
        pushQaRecords?.(
            { recordId: createQaRecordId('questioner'), role: 'questioner', type: 'basic', content },
            {
                filterRecordType: {
                    retry: true,
                    whetherSolve: true,
                    goToTeacherQaTips: true,
                    goToTeacherQa: true,
                    guessYouAsk: true,
                    rechargeTeacherQa: true,
                },
            }
        );
        eventBusExample.publish('DialogueTool', { type: 'hideContinue' });
        eventBusExample.publish('DialogueArea', { type: 'llm', params: { content } });
    };

    return (
        <AnimationContainer className="guess-you-like" type="fade_in">
            {questions.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="guess-you-like__question-container" key={index}>
                    <div className="guess-you-like__question" onClick={() => handleQa(item)}>
                        {item}
                    </div>
                </div>
            ))}
        </AnimationContainer>
    );
};

export default memo(GuessYouAsk);
